import * as React from 'react'
import { getAllCustomFieldsSettings } from '@user/store/customFieldSettings'
import { ENTITY_TYPES } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks'
import type { Dispatch, SetStateAction } from 'react'

type Props = {
  entityType: ENTITY_TYPES
  setDrawerOpen: Dispatch<SetStateAction<boolean>>
}

export function useCustomSettingsSectionHandlers(props: Props) {
  const { entityType, setDrawerOpen } = props
  const dispatch = useAppDispatch()
  const onClose = React.useCallback(async () => {
    setDrawerOpen(false)
    await dispatch(getAllCustomFieldsSettings(entityType))
  }, [dispatch, entityType])

  const onOpen = React.useCallback(() => {
    setDrawerOpen(true)
  }, [setDrawerOpen])

  return {
    onClose,
    onOpen,
  }
}
